<template>
	<nav class="change-plan-nav mt-5 ml-5 b4:pl-4">
		<ol class="flex items-center gap-3 b4:gap-4 text-2 b5:text-3 list-none b4:list-decimal">
			<li class="text-link"><RouterLink :to="selectPlanLink" class="no-underline">Select Plan</RouterLink></li>
			<li :class="{'font-bold': step === 'customize', 'text-link': step === 'checkout'}">
				<button v-if="step === 'checkout'" class="button button--no-style text-2 b5:text-3" @click="$emit('customize')">Customize Plan</button>
				<template v-else>Customize Plan</template>
			</li>
			<li :class="{'font-bold': step === 'checkout', 'text-link': step === 'customize'}">
				<button v-if="step === 'customize'" class="button button--no-style text-2 b5:text-3" @click="$emit('checkout')">Check Out</button>
				<template v-else>Check Out</template>
			</li>
		</ol>
	</nav>
</template>

<script lang="ts">
	import { defineComponent, computed } from 'vue';
	import { useRoute } from 'vue-router/composables';
	import { globalStore } from 'src/stores/global-store';

	export default defineComponent({
		components: {
		},
		props: {
			step: { type: String, required: true }
		},
		emits: ['customize', 'checkout'],
		setup(props, { emit }) {
			const route = useRoute();
			const planBase = computed(() => `/${globalStore.organization ? globalStore.organization.Code : ''}/settings/plan`);

			const selectPlanLink = computed(() => ({
				path: `${planBase.value}/select`,
				query: {
					...(route.query.source ? { source: route.query.source } : {}),
					...(route.query.details ? { details: route.query.details } : {})
				}
			}));

			return {
				selectPlanLink
			};
		}
	});
</script>

<style lang="scss">
.change-plan-nav {

	li:not(:last-child)::after {
		display: inline-block;
		width: var(--spacing-icon);
		height: var(--spacing-icon);
		background: url('~@cognitoforms/shared-components/src/assets/graphics/icons/chevron-right.svg') no-repeat center;
		background-size: contain;
		margin: 0 0 0 var(--spacing-3);
		vertical-align: text-bottom;
		content: '';

		@include b-up($b4) {
			margin: 0 var(--spacing-3);
		}
	}
}
</style>
